import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1001004-bw_582eb06d55__800.jpg";
export const url = url_;